import { solutionColors } from "@smartsuite/types";
import type { CSSProperties } from "react";

export const getSolutionColorStyles = (
  solutionColor: string,
): CSSProperties => {
  const colorPalette = solutionColors.find(
    ({ primary }) => solutionColor === primary,
  );
  return {
    "--solution-primary-color": colorPalette?.primary,
    "--solution-secondary-color": colorPalette?.secondary,
    "--solution-highlight-color": colorPalette?.highlight,
    "--solution-hover-color": colorPalette?.hover,
  } as CSSProperties;
};

const RTL_REGEX = /[\u0590-\u05FF\u0600-\u06FF]+/g;

export function reverseRTLSegments(text: string): string {
  return text.replace(RTL_REGEX, (match) => [...match].reverse().join(""));
}
